define('models/calendar/session/exercise/cardio/phase-week',[
    'underscore', 'backbone',
    // src
    'utils',
], function(
    _, Backbone, U
) {

    var MPhaseWeek = Backbone.Model.extend({
        defaults: {
            duration: 0,
            effort: 0,
            linkRepeat: 1,
        },

        // validate: function(attrs, options) {
        //
        //     var errors = [];
        //     if (attrs.numSets < 1) {
        //         errors.push({ attribute: "numSets", error: "The number of sets must be at least one." });
        //     }
        //     if (attrs.numSets > this.maxSets) {
        //         errors.push({ attribute: "numSets", error: "The maximum of sets is" + this.maxSets + "." });
        //     }
        //     var setsValid = this.getSets().isValid(options);
        //     if (!setsValid) {
        //         errors.push({ attribute: "sets", error: "There are errors within the sets data." });
        //     }
        //
        //     if (errors.length > 0) {
        //         return errors;
        //     }
        // },


    });

    return MPhaseWeek;
});

